import React, { useEffect, useState } from 'react';
import { Container, Modal, Button } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import ModalListPicker from '../../components/Modals/ModalListPicker';
import ModalList from '../../components/Modals/ModalList';
import { toast } from 'react-toastify';



export default function InstanceCompilerTopHook({ data, entity = null, setDataKeyValue, dataId }) {

    useEffect(() => {
        if (entity === 'order_rows') {
            document.getElementById('order_rows_field_sku').querySelector('input').disabled = true;
            document.getElementById('order_rows_field_supplierSku').querySelector('input').disabled = true;
            document.getElementById('order_rows_field_name').querySelector('textarea').disabled = true;
        }
    }, [data]);


    const [modalItemStatus, setModalItemStatus] = useState(false);
    function openModalItem() {
        setModalItemStatus(true)
    }
    function closeModalItem() {
        setModalItemStatus(false)
    }
    function selectItem(row) {
        console.warn(row)
        setDataKeyValue('sku', row.sku)
        setDataKeyValue('supplierSku', row.supplierSku)
        setDataKeyValue('name', row.name)
        setDataKeyValue('price', parseFloat((row.price2).replace(/,/g, '.')).toFixed(3))
        closeModalItem()
    }
    const searchObjValue = {
        'query': '',
        'fields': ['sku', 'supplierSku'],
        'constraints': [
            {
                fieldName: 'outOfStock',
                type: 'different_from_value',
                value: 'E'
            }
        ]
    }
    const sortingValue = { "field": 'quantity', "order": "desc" }


    async function calculatePromo() {
        console.warn(dataId)
        if (data && dataId) {
            const idToast = toast.loading(LanguageProvider.get("toast.loading"))
            var response = await ApiManager.sendAuthenticatedRequest('/custom/apply_cart_promo', { idOrder: dataId });
            toast.update(idToast, { render: 'Promo applicate. Devi riaprire il modale per vedere le modifiche.', type: "success", isLoading: false, autoClose: 1500 });
        }
    }


    /** storico acquisti cliente */
    const [showModalHistory, setShowModalHistory] = useState(false);
    const [showModalHistoryCustomer, setShowModalHistoryCustomer] = useState(null);
    const [showModalHistoryConstraints, setShowModalHistoryConstraints] = useState(null);

    function openModalHistory() {
        console.warn(data)
        setShowModalHistoryCustomer(data.idCustomer.id)
        setShowModalHistoryConstraints({
            'query': '',
            'fields': [],
            'constraints': [
                {
                    fieldName: 'idCustomer',
                    type: 'value',
                    value: data.idCustomer.id
                }
            ]
        })
        setShowModalHistory(true);
    }
    function closeModalHistory() {
        setShowModalHistory(false);
    }


    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'order_rows': return (
                            <>
                                <Container fluid className='mb-4'>
                                    <Button onClick={() => openModalItem()}>Cerca articolo</Button>
                                </Container>

                                {modalItemStatus ? (
                                    <ModalListPicker entity={'gyv_item'} defaultSearchObj={searchObjValue} defaultSorting={sortingValue} modalStatus={modalItemStatus} closeModal={closeModalItem} selectRow={selectItem} />
                                ) : null}
                            </>
                        );
                        case 'customer_order': return (
                            <>
                                <Container fluid className='mb-4 text-end'>
                                    <Button onClick={() => calculatePromo()}>Ri-calcola promo</Button>
                                    <Button onClick={() => openModalHistory()} className='ms-2'>Storico cliente</Button>
                                </Container>

                                {showModalHistory && setShowModalHistoryCustomer ? (
                                    <ModalList modalSorting={{ field: 'invoiceDate', order: 'desc' }} entity='gyv_customer_history' status={showModalHistory} closeModal={closeModalHistory} searchObj={showModalHistoryConstraints}></ModalList>
                                ) : (
                                    null
                                )}
                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};